import { useSelector } from 'react-redux';

import { useAssets } from '@labradorsports/assets';
import { StyledPagination } from '@labradorsports/components';
import { useSite } from '@labradorsports/utils';

import { useDispatcher } from '../../shared/hooks/index.js';
import { useNavigateWithQuery } from '../../shared/providers/index.js';
import { routerActions, RouterSelectors, useSearchCommunityQuery } from '../../store/index.js';
import CommunityPlayList from '../community-play-list/community-play-list.js';

const CommunitySearchPage: FC = () => {
    const { env } = useSite();
    const { SearchEmpty } = useAssets();
    const navigate = useNavigateWithQuery();
    const openCommunityPage = useDispatcher(routerActions.OpenPage);
    const searchText = useSelector(RouterSelectors.communitySearchText);
    const pageNumber = useSelector(RouterSelectors.communityPageNumber);
    const { data: { plays: searchResults, estimatedPages } = {} } = useSearchCommunityQuery({
        query: searchText,
        page: pageNumber,
    });

    const getPageHref = (page: number) => {
        return `${env.baseUrl}/community?q=${searchText}&pg=${page}`;
    };

    return (
        <div className="community-search-page p-3">
            <h3>Search Results</h3>
            <CommunityPlayList plays={searchResults} />
            {searchResults?.length === 0 ? (
                <div className="full-center">
                    <div className="text-center">
                        <img className="empty-results" src={SearchEmpty} alt="" />
                        <p>
                            <b>We couldn't find a good result.</b>
                        </p>
                        <p>
                            Try a new search term or <a onClick={() => navigate(-1)}>go back</a>.
                        </p>
                    </div>
                </div>
            ) : (
                <StyledPagination
                    getHref={getPageHref}
                    count={estimatedPages}
                    page={pageNumber}
                    onChange={openCommunityPage}
                />
            )}
        </div>
    );
};

export default CommunitySearchPage;
